module.exports = __webpack_public_path__ + "static/img/default.9c1515e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units/s_tree1_child/default.png
// module id = 8E9J
// module chunks = 1